module.exports = (__webpack_require__(83520))(22);